import React from 'react';
import { experience, testimonials } from '../data/site';
import { ExperienceCard } from './ExperienceCard';
import { TestimonialItem } from './TestimonialItem';
export function Experience() {
  return <section id="experience" className="bg-paper" data-id="element-32" data-mp="1yspufvcimr63">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 py-20 md:py-24" data-id="element-33" data-mp="1yres7zypxrh3">
        <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-forest" data-id="element-34" data-mp="1tvzcf2h5hli1">
          Selected experience
        </p>
        <h2 className="mt-4 font-serif text-3xl md:text-[2.5rem] leading-tight tracking-tight text-ink" data-id="element-35" data-mp="2mjd68rpjy0xx">
          Judgment built through doing the work.
        </h2>

        <div className="mt-12 grid md:grid-cols-2 gap-5 lg:gap-6 items-stretch" data-id="element-36" data-mp="2hm3gfay93n9k">
          {experience.map(item => <ExperienceCard key={item.id} {...item} data-id="element-37" data-mp="164twyof4gv89" />)}
        </div>

        <div className="mt-16 md:mt-20" data-id="element-38" data-mp="162r2ns6xsfxq">
          <h3 className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-forest" data-id="element-39" data-mp="115hdmdngm6af">
            Client testimonials
          </h3>
          <div className="mt-8" data-id="element-40" data-mp="tn6fsyhpflab">
            {testimonials.map(testimonial => <TestimonialItem key={testimonial.id} {...testimonial} data-id="element-41" data-mp="ynkrcqiildd3" />)}
          </div>
        </div>
      </div>
    </section>;
}